module.exports = __webpack_public_path__ + "static/media/62.fcbf7d17.png";